import api from '@/lib/axios'

export interface ExtractionField {
  id: string
  project_id: string
  name: string
  display_name: string
  description: string | null
  field_type: 'text' | 'number' | 'date' | 'boolean' | 'list'
  extraction_prompt: string | null
  system_prompt_override: string | null
  is_required: boolean
  is_line_item: boolean
  sort_order: number
  created_at: string
}

export interface CreateFieldRequest {
  name: string
  display_name: string
  description?: string
  field_type: 'text' | 'number' | 'date' | 'boolean' | 'list'
  extraction_prompt?: string
  system_prompt_override?: string
  is_required?: boolean
  is_line_item?: boolean
  sort_order?: number
}

export interface FieldPromptSuggestion {
  suggested_prompt: string
}

export const fieldsApi = {
  list: (projectId: string) =>
    api.get<ExtractionField[]>('/fields', { params: { project_id: projectId } }).then((r) => r.data),

  create: (projectId: string, data: CreateFieldRequest) =>
    api.post<ExtractionField>('/fields', data, { params: { project_id: projectId } }).then((r) => r.data),

  get: (fieldId: string) =>
    api.get<ExtractionField>(`/fields/${fieldId}`).then((r) => r.data),

  update: (fieldId: string, data: Partial<CreateFieldRequest>) =>
    api.patch<ExtractionField>(`/fields/${fieldId}`, data).then((r) => r.data),

  delete: (fieldId: string) =>
    api.delete(`/fields/${fieldId}`).then((r) => r.data),

  suggestPrompt: (data: {
    field_name: string
    field_type?: string
    field_description?: string
    project_context?: string
  }) =>
    api
      .post<FieldPromptSuggestion>('/fields/suggest-prompt', data)
      .then((r) => r.data),
}
